import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/index.css"
import 'vuestic-ui/styles/essential.css';
import 'vuestic-ui/styles/typography.css';
import {createVuestic} from 'vuestic-ui'
import {QuillEditor} from '@vueup/vue-quill'
import axios from 'axios'
axios.defaults.withCredentials = true
const app = 
createApp(App)
.use(createVuestic({
    config: {
        colors: {
            variables: {
                primary: '#0098d5',
                secondary: '#2fad29'
            }
        }
    }
}))
.use(store).use(router).component('QuillEditor', QuillEditor).mount('#app');


